import React from 'react';
import Icon from '../../../components/AppIcon';

const ResidentialHero = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary/10 via-background to-accent/10">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-pulse delay-1000" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="inline-flex items-center justify-center mb-6 px-4 py-2 rounded-full bg-primary/10 text-primary border border-primary/20">
          <Icon name="Building" size={20} className="mr-2" />
          <span className="text-sm font-medium">Em Breve</span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-foreground mb-6 leading-tight">
          Apartamentos
          <br />
          <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Residenciais
          </span>
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto mb-8 leading-relaxed">
          O Estação Marina da Rocha está expandindo! Em breve, ofereceremos apartamentos 
          residenciais que combinam conforto, modernidade e sustentabilidade em um único lugar.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 mt-12">
          <div className="flex items-center gap-2 px-6 py-3 rounded-full bg-card border border-border shadow-sm">
            <Icon name="Sun" size={20} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Energia Solar</span>
          </div>
          <div className="flex items-center gap-2 px-6 py-3 rounded-full bg-card border border-border shadow-sm">
            <Icon name="Home" size={20} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Apartamentos Modernos</span>
          </div>
          <div className="flex items-center gap-2 px-6 py-3 rounded-full bg-card border border-border shadow-sm">
            <Icon name="Leaf" size={20} className="text-primary" />
            <span className="text-sm font-medium text-foreground">Vida Sustentável</span>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <Icon name="ChevronDown" size={24} className="text-muted-foreground" />
      </div>
    </section>
  );
};

export default ResidentialHero;
